var _defs, _path, _polyline, _path2, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #3c4347;\n        stroke-linecap: round;\n      }\n\n      .st1 {\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,9.8c2.3,1.1,3.9,3.5,3.9,6.2s-1.8,5.4-4.4,6.4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "19 13.1 19 9.5 22.7 9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,22.2c-2.3-1.1-3.9-3.5-3.9-6.2s1.8-5.4,4.4-6.4"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "13 18.9 13 22.5 9.3 22.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.485d9736708cef152150a71b0703b988.svg";
export { ForwardRef as ReactComponent };